import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
const tomes = [{
  number: 1,
  title: 'El Rescate Psicológico',
  description: 'Cómo funciona el cerebro de tu hijo en la mesa. Qué genera el rechazo. Cómo crear el ambiente correcto para que la exploración sea posible. Las 3 Reglas de Oro que cambian todo desde la primera cena.'
}, {
  number: 2,
  title: 'El Protocolo de 4 Fases',
  description: 'El sistema gradual para pasar de "no lo mira" a "lo prueba". Fase 1: Tolerancia Visual. Fase 2: Interacción Sin Presión. Fase 3: El Puente del Aroma. Fase 4: El Micro-Bocado. Con actividades concretas y señales de avance para cada fase.'
}, {
  number: 3,
  title: 'El Protocolo de Desconexión',
  description: 'Cómo retirar la tablet de la mesa en 7 días sin huelga de hambre ni crisis. Día por día. Con sustitutos sensoriales y manejo de crisis incluido. Para que la pantalla deje de ser la única forma de que coma.'
}, {
  number: 4,
  title: 'El Recetario de Expansión',
  description: 'Los 20 Alimentos Puente del método. El Mapping de Texturas completo. 30 recetas de expansión para el hogar argentino. La Lista de Compras Anti-Estrés. Con ingredientes de cualquier almacén argentino.'
}];
export function TomesSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="w-full py-20 md:py-24 px-4 bg-warm-cream" data-id="element-248">
      <div className="max-w-6xl mx-auto" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-250">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-heading" data-id="element-251">
            LOS 4 TOMOS
          </h2>
          <div className="w-24 h-1 bg-primary-green mx-auto mt-6 rounded-full" data-id="element-252"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-253">
          {tomes.map(tomo => <motion.div key={tomo.number} variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-md shadow-secondary-coral-light/10 border border-warm-cream hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-id="element-254">
              <div className="flex items-center mb-6" data-id="element-255">
                <div className="w-12 h-12 bg-light-green rounded-xl flex items-center justify-center mr-4" data-id="element-256">
                  <BookOpenIcon className="w-6 h-6 text-primary-green" data-id="element-257" />
                </div>
                <div className="px-3 py-1 bg-primary-green/10 text-primary-green font-bold text-sm rounded-full" data-id="element-258">
                  TOMO {tomo.number}
                </div>
              </div>

              <h3 className="text-xl md:text-2xl font-heading font-bold text-text-heading mb-4 leading-snug" data-id="element-259">
                {tomo.title}
              </h3>

              <p className="text-text-body text-lg leading-relaxed" data-id="element-260">
                {tomo.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}